import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { Avatar } from 'components/Avatar';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { clientInitials, fullName } from 'domains/client';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { MenuLinks } from './MenuLinks';

export const AccountMenu = (): JSX.Element | null => {
  const { clients, activeClientId, activeClient, signOut, changeClient } = useUserClientsWithActiveClient();

  const otherClients = clients.filter(c => c.clientID !== activeClientId);

  if (!activeClient) {
    throw new Error('Expected a client but there was none.');
  }

  return (
    <Menu as="div" className="relative z-20 inline-block text-left">
      <div>
        <Menu.Button as={Button} variant="text" className="text-gray-900 font-medium px-8 md:px-12 min-w-[56px]">
          <span className="sr-only">account menu</span>

          <Avatar>{clientInitials(activeClient)}</Avatar>
          <div data-testid="index-current-client-name">
            <span className="sm-d:sr-only mx-12 font-medium">{fullName(activeClient)}</span>
          </div>
          <Icon name="ChevronDown" className="w-16 h-16 hidden sm:block" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute right-0 mt-2 min-w-[300px] md:min-w-[360px] rounded-md shadow-lg bg-white ring-1 ring-gray-300 focus:outline-none overflow-hidden">
          <MenuLinks
            currentClient={activeClient}
            otherClients={otherClients}
            onSelectClient={changeClient}
            onLogOut={signOut}
          />
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
